import { SAVE_ACCOMMODATION_DESCRIPTION } from "app/actionTypes";

/**
 * Pousse dans le store la description d'hébergement récupérée par
 * `useHotelAccommodationDescription` (react-query), pour les consommateurs
 * qui lisent encore `state.ficheProduit` (analytics, Datadog, ProductSummary,
 * page de paiement...).
 */
export const saveAccommodationDescription = accommodation => {
	return {
		type: SAVE_ACCOMMODATION_DESCRIPTION,
		accommodation,
	};
};
